import {  createContext, useContext } from "react";


const signupDataContext = createContext();
const useSignUpContext = () => useContext(signupDataContext);

export {signupDataContext, useSignUpContext};